function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 20.3989C0 20.3989 18.1359 16.2162 19.9878 0C19.9878 0 31.163 14.2857 47 11.8404C47 11.8404 37.8682 23.1659 45.1481 41.6987C45.1481 41.6987 28.6087 34.2985 15.1984 49.9998C15.1984 50.0642 14.3682 31.3384 0 20.3989Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7161 26.9757C31.6889 26.9653 31.6585 26.9773 31.6472 27.0035C31.3489 27.6959 30.5484 29.7185 28.3182 29.7185C25.8926 29.7185 23.5983 26.5486 22.6131 25.0773C22.5961 25.0517 22.6206 25.0186 22.651 25.0276C24.3156 25.4998 26.9092 25.44 28.5578 24.3053C29.765 23.4746 30.9818 22.3644 31.7252 19.6217C31.7348 19.5855 31.7124 19.5478 31.675 19.5389L28.8305 18.8774C28.7937 18.869 28.7574 18.891 28.7488 18.9272C28.3304 20.6773 27.0736 22.8377 23.7563 22.192C23.7392 22.1889 23.7269 22.1731 23.7285 22.1564L24.3444 14.5449C24.3471 14.5103 24.3225 14.4794 24.2878 14.4737L21.4086 14.0009C21.3691 13.9946 21.3328 14.0224 21.3296 14.0612L20.7602 20.8895C20.7581 20.9173 20.7244 20.9304 20.7036 20.9116C20.3669 20.6107 19.9266 20.1301 19.5765 19.7354C19.5546 19.7102 19.5178 19.7055 19.4895 19.7233C19.1672 19.9246 17.3564 21.0552 17.0308 21.2585C17.0031 21.2758 16.9919 21.3136 17.0063 21.3424C17.6878 22.7319 19.3385 25.58 20.2361 26.8295C20.2543 26.8552 20.2628 26.8851 20.2601 26.9165C20.219 27.4129 19.8684 31.6227 19.822 32.1793C19.8193 32.2139 19.8439 32.2443 19.8786 32.2501L22.801 32.7365C22.8405 32.7433 22.8773 32.715 22.88 32.6757L23.0582 30.445C23.0604 30.4167 23.0945 30.4041 23.1153 30.424C24.5472 31.7747 26.1888 32.7249 27.9248 32.749C29.5515 32.7716 32.6927 32.4288 34.496 28.1377C34.5072 28.111 34.4939 28.0796 34.4667 28.0686L31.7161 26.9757Z",
  fill: "white"
});

var SvgTkCircleAvatar = function SvgTkCircleAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTkCircleAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tk-circle-avatar.2eb3a250.svg";
export { ForwardRef as ReactComponent };